import { render, staticRenderFns } from "./footer-headline.vue?vue&type=template&id=15ea2502&"
import script from "./footer-headline.vue?vue&type=script&lang=js&"
export * from "./footer-headline.vue?vue&type=script&lang=js&"
import style0 from "./footer-headline.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports